import { render, staticRenderFns } from "./IbModal.vue?vue&type=template&id=083e5f1a&scoped=true"
import script from "./IbModal.vue?vue&type=script&lang=js"
export * from "./IbModal.vue?vue&type=script&lang=js"
import style0 from "./IbModal.vue?vue&type=style&index=0&id=083e5f1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e5f1a",
  null
  
)

export default component.exports